export const tableHeaders = [
  { label: 'CMS Id', value: 'cmsPageId' },
  { label: 'Title', value: 'title' },
  { label: 'Category', value: 'category' },
  { label: 'Status', value: 'isActive' },
  { label: 'Slug', value: 'slug' },
  { label: 'Content', value: 'content' }
]
export const category = ['Support', 'About', 'Responsible Gaming']

export const tableColumnHeaders =[
  { value: 'id', label: 'Id', accessorKey: 'cmsPageId', Header: 'cmsPageId' },
  { value: 'title', label: 'Title', accessorKey: 'title', Header: 'Title' },
  { value: 'slug', label: 'Slug', accessorKey: 'slug', Header: 'Slug' },
  { value: 'Category', label: 'category', accessorKey: 'category', Header: 'category' },
  // { value: 'portal', label: 'Portal', accessorKey: 'portal', Header: 'Portal' },
  { value: 'status', label: 'Status', accessorKey: 'status', Header: 'Status' },
  // { value: 'action', label: 'Action', accessorKey: 'action', Header: 'Action' }
]


export  const categoryLinkOptions = [
  { value: 1, label: 'Support Links' },
  { value: 2, label: 'Other Links' },
];
